import './style.css';

function WhoAmI(){
    return (
        <div id="whoami" className="box-container">
        <h1 className="box-container-title">Who Am I ?</h1>
        <p className="box-container-content">
        My name is Allan Brito dos Santos, I work as Back-End Developer in a tecnology company but I have been in the programming area for 10 years. I started programming for Industrial Automation, coding for PLCs (Programming Logic Controllers) Devices that act for monitoring and supervision of HVAC (Air Conditioning). Then, I changed to Comercial Automation programming. At the last company that I worked for, I contributed at the implementation of new features in software to attend pubs and restaurants. And then our team grew the customer's range and we make a deal with the most important Brazil's delivery app. Beyond back-end, I code in front-end using JavaFx, JavaScript and React. You can see and follow my projects and system's portfolios accessing my GitHub or going in "Projects" section down below.
        </p>
        </div>
    )
}

export default WhoAmI;